export const DevSkills = [
  "React.js",
  "Javascript",
  "HTML5",
  "CSS",
  "TypeScript",
  "Jest",
  "Storybook",
  "React Query",
  "Git",
  "WCAG",
  "Scss",
  "React Testing Library",
];

export const SoftSkills = [
  "Communication",
  "Organization", "Product Demo", "Training", "Teaching", "Public speaking","Community Building"
]

export const ArtSkills = [
  "Figma", "Inkscape", "Blender", "Photoshop"
]
export const AlienTorontoParty = [
  "20 minute circle performance","live reading, a crabwalking tutorial, and an invitation to participate in a private reading",
  "1.5 hours of Alien Tarot Reading - where guests ask about their own best timeline",
  "10 min - Choreographed photos of each reading, as well as group photos at the end of performance",
  "30 min - set up / strike alien set",
"Custom decorations available upon request"

]
export const AlienBirthday = [
  "7 card reading about desire, growth and initiative",
  "Full sparkling alien tarot action, with reversible sequin tentacles, amazing dance moves, high kicks, deep questions and cosmic comedy for one.",
  "Birthday Reading to help honour the old you and welcome the new opportunities",
  "Full Alien flavour, full privacy."
]

export const AlienBusker = [
  "Standup comedy routine with audience participation",
  "5 minute alien tarot reading with audience member",
  "5 minute alien dance routine with tutorial for crab walking"
]